import {EmergencyType} from 'app/shared/model/enumerations/emergency-type.model';
import {FollowupType} from "app/shared/model/enumerations/followup-type.model";

export interface IFollowup {
  id?: string;
  followupType?: FollowupType;
  emergencyType?: EmergencyType;
  enFollowup?: string;
  stFollowup?: string;
  countryId?: string;
  isActive?:boolean;
  isCondition?:boolean;
  isAlive?:boolean;
  isDelivered?:boolean;

}

export const defaultValue: Readonly<IFollowup> = {};
